import {IApiEndpoint, IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {IFlag} from "@models/shared/IFlag.ts";
import {IGetFlagsFilter} from "@localization/siteMap/endpoints/flags/filters/IGetFlagsFilter.ts";

export const __flags_endpoints = {
    ['CreateFlag']: (body: Pick<IFlag, 'nome' | 'tipo' | 'ordem' | 'descricao'>): IApiEndpoint<IFlag> => {
        return {
            url: '/api/Flag/CreateFlag',
            method: 'POST',
            body: body
        }
    },
    ['GetFlags']: ({filters, pagination}: {
        filters?: IGetFlagsFilter,
        pagination?: IPagination
    }): IApiEndpoint<IFlag[]> => {
        return {
            url: '/api/Flag/GetFlags',
            method: 'GET',
            query: filters,
            pagination: pagination,
        }
    }
} as const;